import React, { useState, useEffect, useRef } from "react";
import "./resultPage.css";
import { withRouter } from "react-router-dom";
import Result from "../../components/result/Result";
import ThemeRegionDiv from "../../components/theme-region-div/ThemeRegionDiv.jsx";
import Footer from "../../components/footer/Footer.jsx";
import { utils } from "../../utils/Utils.jsx";

const ResultPage = (props) => {
  const [isMobileWidth, setIsMobileWidth] = useState(false);
  const [shouldAutoDownload, setShouldAutoDownload] = useState(false);
  const resultRef = useRef(null);

  const checkWindowWidth = () => {
    const windowSize = window.innerWidth;
    const flag = windowSize <= 950;
    setIsMobileWidth(flag);
  };

  useEffect(() => {
    console.log("ResultPage props", props);

    // Check if we're inside dashboard (has URL params) or outside (uses megastate)
    if (props.resultType === "outside" && !props.location.megastate) {
      // Outside dashboard but no megastate - redirect appropriately
      utils.goToURL(props, "/");
      return;
    }

    if (
      props.resultType === "inside" &&
      !props.match.params.success &&
      !props.match.params.type
    ) {
      utils.goToURL(props, "/dashboard");
      return;
    }

    if (props.location.megastate && props.location.megastate.bankData) {
      // Set flag to trigger auto download
      setShouldAutoDownload(true);
    }

    checkWindowWidth();
    window.addEventListener("resize", checkWindowWidth);

    return () => {
      window.removeEventListener("resize", checkWindowWidth);
    };
  }, []);

  const getSuccess = () => {
    console.log("getSuccess", props);
    if (props.resultType === "inside") {
      return props.match.params.success === "true";
    } else {
      return props.location.megastate?.success || false;
    }
  };

  const getResultType = () => {
    if (props.resultType === "inside") {
      return props.match.params.type;
    } else {
      return props.location.megastate?.type || "";
    }
  };

  const getResultMessage = () => {
    const type = getResultType();
    const success = getSuccess();

    // Inside dashboard result types
    if (type === "deposit") {
      if (success) {
        return props.localizedText["we-are-waiting-for-your-deposit"];
      } else {
        return props.localizedText[
          "unfortunately-we-have-encountered-a-problem-while-trying-to-make-your-deposit"
        ];
      }
    } else if (type === "delete-vendor") {
      if (success) {
        return props.localizedText["the-vendor-was-deleted-successfully"];
      } else {
        return props.localizedText[
          "unfortunately-we-have-encountered-a-problem-while-trying-to-delete-the-vendor"
        ];
      }
    }
    // Outside dashboard result types
    else if (type === "register") {
      if (success) {
        return props.localizedText["your-account-was-successfully-created"];
      } else {
        return props.localizedText[
          "unfortunately-we-couldn't-create-your-account"
        ];
      }
    } else if (type === "corporate-register") {
      if (success) {
        return props.localizedText[
          "corporate-information-was-succesfully-uploaded"
        ];
      } else {
        return props.localizedText[
          "unfortunately-we-couldnt-upload-your-corporate-information"
        ];
      }
    } else if (type === "forgot-password") {
      if (success) {
        return props.localizedText[
          "a-temporary-password-has-emailed-to-your-account"
        ];
      } else {
        return props.localizedText[
          "unfortunately-we-have-encountered-a-problem-while-trying-to-generate-a-new-password"
        ];
      }
    } else if (type === "change-password") {
      if (success) {
        return props.localizedText["your-password-was-successfully-changed"];
      } else {
        return props.localizedText[
          "unfortunately-we-have-encountered-a-problem-while-trying-to-change-your-password"
        ];
      }
    } else if (type === "delete-account") {
      if (success) {
        return props.localizedText["your-account-was-successfully-deleted"];
      } else {
        return props.localizedText[
          "unfortunately-we-couldn't-delete-your-account"
        ];
      }
    } else if (type === "deactivate-account") {
      if (success) {
        return props.localizedText["your-account-was-successfully-deactivated"];
      } else {
        return props.localizedText[
          "unfortunately-we-couldn't-deactivate-your-account"
        ];
      }
    } else if (type === "test") {
      if (success) {
        return "This is a test result page - everything is working correctly!";
      } else {
        return "This is a test result page - showing failure state.";
      }
    }

    // Default message
    return "";
  };

  const getReturnURL = () => {
    if (props.resultType === "inside") {
      return props.location.megastate?.returnURL || "/dashboard";
    } else {
      return "/";
    }
  };

  const getPrimaryButtonFunction = () => {
    if (props.location.megastate?.primaryButtonFunction) {
      return props.location.megastate.primaryButtonFunction;
    }
    return utils.goToURL.bind(null, props, getReturnURL());
  };

  const getSecondaryButtonFunction = () => {
    return props.location.megastate?.secondaryButtonFunction || null;
  };

  const hasSecondButton = () => {
    return props.location.megastate?.secondButton || false;
  };

  const success = getSuccess();
  const bankData = props.location.megastate?.bankData || null;

  console.log("ResultPage megastate", props.location.megastate);
  console.log("bankData", bankData);

  return (
    <div
      className={
        props.resultType === "outside" ? "outside-result-container" : ""
      }
    >
      <Result
        ref={resultRef}
        success={success}
        secondButton={hasSecondButton()}
        title={props.localizedText[utils.getResultTitle(success)]}
        message={getResultMessage()}
        primaryButtonText={props.localizedText["continue"]}
        primaryButtonFunction={getPrimaryButtonFunction()}
        secondaryButtonText={props.localizedText["continue"]}
        secondaryButtonFunction={getSecondaryButtonFunction()}
        receipt={
          bankData
            ? {
                data: bankData,
                fileName: props.localizedText["bank-deposit-details"],
              }
            : null
        }
        autoDownload={shouldAutoDownload}
        theme={props.theme}
        localizedText={props.localizedText}
        isMobileWidth={isMobileWidth}
        resultType={props.resultType}
      ></Result>

      {/* Only show ThemeRegionDiv and Footer for outside dashboard results */}
      {props.resultType === "outside" && (
        <>
          <ThemeRegionDiv
            config={props.config}
            changeTheme={props.changeTheme}
            theme={props.theme}
            handleModalOpen={props.handleModalOpen}
            region={props.region}
            localizedText={props.localizedText}
          ></ThemeRegionDiv>
          <Footer
            region={props.region}
            localizedText={props.localizedText}
            theme={props.theme}
          ></Footer>
        </>
      )}
    </div>
  );
};

export default withRouter(ResultPage);
